import ExceptionService from './ExceptionService.js'
import ApplicationException from './ApplicationException.js'
import ConfigUtil from './services/ConfigUtil.js'
import BerechtigungUtil from './services/BerechtigungUtil'

export default class BaseService {

  constructor(relativeBase) {
    this.backendUrl = ''
    this.relativeBase = relativeBase
    this.logging = new ExceptionService()
    this.configUtil = new ConfigUtil()
    this.berechtigungUtil = new BerechtigungUtil()
  }

  retrieveBackendUrl() {
    return this.configUtil.retrieveConfiguration()
      .then(config => {
        this.backendUrl = `${config.backendUrl}/${this.relativeBase}`
      })
      .catch(error => {
        this.logging.log(error)
      })
  }

  async getBackendListUrl(serviceName) {
    await this.retrieveBackendUrl()
    return serviceName ? `${this.backendUrl}/${serviceName}` : this.backendUrl
  }

  async list(serviceName) {
    await this.getBackendListUrl(serviceName).then(url => this.serviceurl = url)
    return this.checkError(
      fetch(this.serviceurl, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async search(serviceName, params, method = 'GET') {
    await this.getBackendListUrl(serviceName).then(url => this.serviceurl = constructURL({to: url, params: params}))
    return this.checkError(
      fetch(this.serviceurl, {
        method: method,
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async create(object, commandSuffix = '') {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(this.backendUrl + commandSuffix, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(object)
      })
    )
  }

  async read(id, subResource = '') {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${id}/${subResource}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async update(object, serviceName) {
    await this.retrieveBackendUrl()
    const url = (serviceName) ? `${this.backendUrl}/${serviceName}` : this.backendUrl
    return this.checkError(
      fetch(`${url}/${object.id}`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(object)
      })
    )
  }

  async delete(id) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${id}`, {
        method: 'DELETE',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async checkError(promise) {
    this.configUtil.updateToken()
    return promise
      .then(result => {
        if (result.ok) {
          const contentType = result.headers.get('content-type')
          if (contentType && contentType.indexOf('application/json') !== -1) {
            return result.json()
          } else {
            return result
          }
        } else {
          if(result.status !== 428) {
            result.json().then(err => showAlert(err.title, err.detail, 'error', err.reasons.map(reason => `${reason.field}: ${reason.text}`)))
          }
          throw new ApplicationException()
        }
      })
      .catch(error => {
        if (error instanceof ApplicationException) {
          throw error
        } else {
          showAlert('Service unavailable', 'Request to backend could not be sent', 'error')
          this.logging.log(error)
        }
      })
  }

  getJsonHeader() {
    const headers = {
      'Authorization': 'Bearer ' + window.keycloak.token,
      'Content-Type': 'application/json',
      'Accept-Language': getLanguage()
    }
    const activeProfile = this.berechtigungUtil.getActiveProfile()
    if(activeProfile) {
      headers['X-Profile'] = activeProfile.uuid
    }
    return headers
  }
}
